// This file should not contain any async code in order to minimize latency
const url = new URL(window.location.href);
const path = url.pathname.split("/").slice(1, undefined); // ["<modulnavn>", ...]
const module = path[0];

export { path, module };
